import { apiProxyRequest } from "Api/apiProxyRequest";
import { fetchAllPages } from "Api/utils";

import { Organization } from "@packages/client";

export type ProfileOrganizationsResponse = {
  count: number;
  items: Array<Organization>;
  _links: Record<string, { href: string }>;
};

export const getProfileOrganizations = (billingProfileId: string) => {
  return fetchAllPages(
    apiProxyRequest<ProfileOrganizationsResponse>(
      `/billing/profiles/${billingProfileId}/organizations`
    )
  );
};
